function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import toolCom from '@/components/PageDiy/mobileConfigRight/index.js';
import rightBtn from '@/components/PageDiy/rightBtn/index.vue';
export default {
  name: 'c_home_menu',
  cname: '导航组',
  componentsName: 'home_menu',
  props: {
    activeIndex: {
      type: null
    },
    num: {
      type: null
    },
    index: {
      type: null
    }
  },
  components: _objectSpread(_objectSpread({}, toolCom), {}, {
    rightBtn: rightBtn
  }),
  data: function data() {
    return {
      configObj: {},
      rCom: [{
        components: toolCom.c_checked_tab,
        configNme: 'setUp'
      }],
      oneStyle: [{
        components: toolCom.c_title,
        configNme: 'tabConfig'
      }, {
        components: toolCom.c_txt_tab,
        configNme: 'tabConfig'
      }, {
        components: toolCom.c_txt_tab,
        configNme: 'rowsNum'
      }, {
        components: toolCom.c_txt_tab,
        configNme: 'number'
      }, {
        components: toolCom.c_title,
        configNme: 'menuConfig'
      }, {
        components: toolCom.c_menu_list,
        configNme: 'menuConfig'
      }],
      twoStyle: [{
        components: toolCom.c_title,
        configNme: 'tabConfig'
      }, {
        components: toolCom.c_txt_tab,
        configNme: 'tabConfig'
      }, {
        components: toolCom.c_title,
        configNme: 'menuConfig'
      }, {
        components: toolCom.c_menu_list,
        configNme: 'menuConfig'
      }],
      configStyle: [{
        components: toolCom.c_title,
        configNme: 'bgColor'
      }, {
        components: toolCom.c_bg_color,
        configNme: 'bgColor'
      }, {
        components: toolCom.c_bg_color,
        configNme: 'titleColor'
      }, {
        components: toolCom.c_title,
        configNme: 'upConfig'
      }, {
        components: toolCom.c_slider,
        configNme: 'upConfig'
      }, {
        components: toolCom.c_slider,
        configNme: 'downConfig'
      }, {
        components: toolCom.c_slider,
        configNme: 'lrConfig'
      }, {
        components: toolCom.c_slider,
        configNme: 'contentConfig'
      }, {
        components: toolCom.c_slider,
        configNme: 'mbConfig'
      }, {
        components: toolCom.c_title,
        configNme: 'bgStyle'
      }, {
        components: toolCom.c_slider,
        configNme: 'bgStyle'
      }, {
        components: toolCom.c_slider,
        configNme: 'contentStyle'
      }],
      type: 0,
      setUp: 0
    };
  },
  watch: {
    num: function num(nVal) {
      var value = JSON.parse(JSON.stringify(this.$store.state.mobildConfig.defaultArray[nVal]));
      this.configObj = value;
    },
    configObj: {
      handler: function handler(nVal, oVal) {
        this.$store.commit('mobildConfig/UPDATEARR', {
          num: this.num,
          val: nVal
        });
      },
      deep: true
    },
    'configObj.setUp.tabVal': {
      handler: function handler(nVal, oVal) {
        this.setUp = nVal;
        var arr = [this.rCom[0]];
        if (nVal == 0) {
          if (this.type == 0) {
            this.rCom = arr.concat(this.twoStyle);
          } else {
            this.rCom = arr.concat(this.oneStyle);
          }
        } else {
          this.rCom = arr.concat(this.configStyle);
        }
      },
      deep: true
    },
    'configObj.tabConfig.tabVal': {
      handler: function handler(nVal, oVal) {
        this.type = nVal;
        var arr = [this.rCom[0]];
        if (this.setUp === 0) {
          if (nVal == 0) {
            this.rCom = arr.concat(this.twoStyle);
          } else {
            this.rCom = arr.concat(this.oneStyle);
          }
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var value = JSON.parse(JSON.stringify(_this.$store.state.mobildConfig.defaultArray[_this.num]));
      _this.configObj = value;
    });
  },
  methods: {
    getConfig: function getConfig(data) {}
  }
};